// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-table-styles_table__DbpG2 {
    --column-width: 340px;
    display: grid;
    /*grid-template-columns: 240px auto var(--column-width);*/
    /*grid-template-columns: 1fr var(--container-width) 1fr;*/
    grid-template-columns: 1fr clamp(200px, 85vh, 50vw) 1fr;

    grid-gap: 24px;
    margin: auto;
    width: 100vw;
    /*width: calc(100vw + var(--sidebar-collapsed-width));*/
    /*left: calc(var(--sidebar-collapsed-width) * -1);*/
    /*position: relative;*/
    /*width: 1800px;*/
    /*width: calc(100vw - calc(var(--container-padding)) * 2);*/
    /*width: var(--container-width);*/
    padding: 18px var(--container-padding) 18px var(--container-padding);
    max-width: 100%;
    /*display: flex;*/
}

/*.table.legal-structures {*/
/*    grid-template-columns: 1fr clamp(200px, 75vh, 40vw) 1fr;*/
/*}*/

.result-table-styles_table__DbpG2.result-table-styles_main__r-zpW {
    /*height: calc(100vh - var(--header-height));*/
    min-height: 73vh;
}

.result-table-styles_table__DbpG2.result-table-styles_legal-structures__wq9lN {
    /*width: calc(100vw - 60px);*/
}

.result-table-styles_tableCenter__hcoRv,
.result-table-styles_tableCenter__hcoRv div {
    /*margin: auto 0;*/
    /*padding: 40px 0;*/
    /*width: 100vw;*/
    /*min-width: var(--container-width);*/
    /*max-width: var(--container-width);*/
    /*width: clamp(100vw, 70vw, 70vw);*/
    max-height: calc(100vh - var(--header-height) - 80px);
}

.result-table-styles_tableRight__o03NB,
.result-table-styles_tableLeft__i-6cC,
.result-table-styles_tableCenter__hcoRv {
    /*flex: 1;*/
}

.result-table-styles_tipsRight__XQx5v {
    margin: auto 0 0 auto;
    transition: opacity 0.4s;
    position: relative;
    width: 260px;
    max-width: 100%;
}

.result-table-styles_tableRight__o03NB {
    position: relative;
}

.result-table-styles_tableRight__o03NB,
.result-table-styles_tableRight__o03NB > div,
.result-table-styles_tableLeft__i-6cC {
    display: flex;
    flex-direction: column;
    row-gap: 60px;
    max-height: calc(100vh - var(--header-height));
}

.result-table-styles_tableRight__o03NB > div {
    flex: 1 1;
}

.result-table-styles_bottomDetails__xAXye {
    transition: opacity 0.4s;
}

/*.tableRight > div > div:first-child,*/
/*.tableRight > div > div:last-child,*/
/*.tableLeft > div:first-child,*/
/*.tableLeft > div:last-child {*/
/*    height: 200px;*/
/*}*/

.result-table-styles_tableLeft__i-6cC {
    position: relative;
}

.result-table-styles_tableBottom__2gv-Q {
    margin: auto 0 0 0;
    position: absolute;
    transition: left 0.4s;
    left: 0;
}

@media (max-width: 1920px) {
    .result-table-styles_hidden__Ebnio {
        display: none;
    }
}

@media (max-width: 2000px) and (min-width: 1570px) {
    .result-table-styles_tableBottom__2gv-Q {
        width: 27vw;
    }
}

@media (max-width: 1570px) and (min-width: 1320px) {
    .result-table-styles_tableBottom__2gv-Q {
        width: 27vw;
    }
}

.result-table-styles_graphTip__BwyuE {
    width: 100%;
    /*width: 340px;*/
    /*min-width: 340px;*/
    font-weight: 300;
    margin: auto 0 0;
    /*font-size: 12px;*/
}

.result-table-styles_details__ukQVR {
    height: auto !important;
    margin: auto;
    right: 0;
    left: 0;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    width: 300px;
    max-width: 100%;
}

.result-table-styles_actions__i7Fpz {
    display: flex;
    column-gap: 169px;
    row-gap: 16px;
    flex-wrap: wrap;
    width: 100%;
}

.result-table-styles_actions__i7Fpz button,
.result-table-styles_actions__i7Fpz a {
    width: 100%;
}

.result-table-styles_btnContainer__\\+qDL6 {
    margin-top: 30px;
}

.result-table-styles_checkboxesWrapper__5h5Jp {
    --width: 400px;
    overflow: hidden;
    width: var(--width);
    margin-left: calc((var(--width) - var(--column-width)) / 2 * -1);
}

.result-table-styles_checkboxes__Xp9E2 {
    position: relative;
    background: #fff;
    padding: 25px 58px;
    width: 322px;
    border-radius: 10px;
    border: 1px solid var(--primary-color);
    margin-top: 20px;
    margin-left: 200px;
    opacity: 0;
    transition:
        margin 0.4s,
        opacity 0.4s;
}

.result-table-styles_checkboxes__Xp9E2:not(.result-table-styles_checkOpen__VL3Nl) {
    pointer-events: none;
}

.result-table-styles_checkboxes__Xp9E2.result-table-styles_checkOpen__VL3Nl {
    margin-left: 0;
    opacity: 1;
}

.result-table-styles_checks__i1Rua {
    width: 160px;
    position: relative;
    z-index: 90;
    max-width: 100%;

    /*margin-top: 100px*/
}

.result-table-styles_fofChecks__yXqDM {
    max-width: 100%;
    width: 225px;
    margin-left: auto;
    margin-top: 100px;
    position: relative;
    z-index: 10;
}

.result-table-styles_detailsPlaceholder__qqTMW {
    margin: auto 0 0 auto;
    padding-top: 30vh;
    color: var(--primary-color);
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: absolute;
    z-index: 1;
    /*text-align: center;*/
    left: 0;
    right: 0;
    width: 260px;
    transition: opacity 0.4s;
    max-width: 100%;
}

.result-table-styles_detailsPlaceholderImg__qubrD {
    width: 20px;
    min-width: 20px;
    transform: rotate(180deg);
    /*margin: auto*/
    position: absolute;
    left: -26px;
}

/*@media (max-width: 1920px) {*/
/*    .table {*/
/*        width: 100vw;*/
/*    }*/
/*}*/

/*@media (max-height: 1200px) {*/
/*    .tipsRight.checkOpen {*/
/*        opacity: 0;*/
/*    }*/
/*}*/

@media (min-width: 3000px) {
    .result-table-styles_table__DbpG2 {
        grid-template-columns: 1fr var(--container-width) 1fr;
    }
}

@media (min-width: 2000px) {
    .result-table-styles_details__ukQVR {
        margin: auto auto;
        right: 0;
        left: 0;
    }

    .result-table-styles_tipsRight__XQx5v {
        margin: auto;
    }

    .result-table-styles_detailsPlaceholder__qqTMW {
        margin: auto;
        left: 0;
        right: 0;
    }
}

/*@media (min-width: 2000px) and (max-width: 3000px) {*/
/*    .table {*/
/*        grid-template-columns: 1fr 50vw 1fr;*/
/*    }*/
/*}*/

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .result-table-styles_table__DbpG2 {
        padding-top: 50px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-max"]} {
    .result-table-styles_table__DbpG2 {
        /*grid-template-columns: 1fr 40vh 1fr;*/
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .result-table-styles_table__DbpG2 {
        --column-width: 340px;
        /*grid-template-columns: calc(var(--column-width) - var(--sidebar-collapsed-width)) auto var(--column-width);*/
    }

    .result-table-styles_tipsRight__XQx5v,
    .result-table-styles_tableBottom__2gv-Q {
        position: absolute;
        bottom: 0;
    }

    .result-table-styles_tipsRight__XQx5v {
        margin: auto;
        /*left: 0;*/
        right: 0;
    }

    .result-table-styles_bottomDetails__xAXye:not(.result-table-styles_active__5RALC) {
        opacity: 0;
    }
}

.result-table-styles_bottomDetails__xAXye:not(.result-table-styles_active__5RALC) .result-table-styles_detailsPlaceholder__qqTMW {
    opacity: 0;
}

@media (min-width: 1920px) {
    .result-table-styles_hidden__Ebnio {
        left: var(--sidebar-expanded-width);
    }

    .result-table-styles_details__ukQVR {
        width: 370px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ResultTable/result-table-styles.module.css"],"names":[],"mappings":"AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yDAAyD;IACzD,yDAAyD;IACzD,uDAAuD;;IAEvD,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,uDAAuD;IACvD,mDAAmD;IACnD,sBAAsB;IACtB,iBAAiB;IACjB,2DAA2D;IAC3D,iCAAiC;IACjC,oEAAoE;IACpE,eAAe;IACf,iBAAiB;AACrB;;AAEA,4BAA4B;AAC5B,+DAA+D;AAC/D,IAAI;;AAEJ;IACI,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,qCAAqC;IACrC,mCAAmC;IACnC,qDAAqD;AACzD;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,uCAAuC;AACvC,sCAAsC;AACtC,gCAAgC;AAChC,gCAAgC;AAChC,qBAAqB;AACrB,IAAI;;AAEJ;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;AACX;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,QAAQ;IACR,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV;;oBAEgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;;IAEf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA,+BAA+B;AAC/B,eAAe;AACf,wBAAwB;AACxB,QAAQ;AACR,IAAI;;AAEJ,gCAAgC;AAChC,6BAA6B;AAC7B,sBAAsB;AACtB,QAAQ;AACR,IAAI;;AAEJ;IACI;QACI,qDAAqD;IACzD;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,QAAQ;QACR,OAAO;IACX;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,OAAO;QACP,QAAQ;IACZ;AACJ;;AAEA,uDAAuD;AACvD,eAAe;AACf,+CAA+C;AAC/C,QAAQ;AACR,IAAI;;AAEJ;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,uCAAuC;IAC3C;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,8GAA8G;IAClH;;IAEA;;QAEI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min, screen-lg-max from '../../breakpoints.css';\n\n.table {\n    --column-width: 340px;\n    display: grid;\n    /*grid-template-columns: 240px auto var(--column-width);*/\n    /*grid-template-columns: 1fr var(--container-width) 1fr;*/\n    grid-template-columns: 1fr clamp(200px, 85vh, 50vw) 1fr;\n\n    grid-gap: 24px;\n    margin: auto;\n    width: 100vw;\n    /*width: calc(100vw + var(--sidebar-collapsed-width));*/\n    /*left: calc(var(--sidebar-collapsed-width) * -1);*/\n    /*position: relative;*/\n    /*width: 1800px;*/\n    /*width: calc(100vw - calc(var(--container-padding)) * 2);*/\n    /*width: var(--container-width);*/\n    padding: 18px var(--container-padding) 18px var(--container-padding);\n    max-width: 100%;\n    /*display: flex;*/\n}\n\n/*.table.legal-structures {*/\n/*    grid-template-columns: 1fr clamp(200px, 75vh, 40vw) 1fr;*/\n/*}*/\n\n.table.main {\n    /*height: calc(100vh - var(--header-height));*/\n    min-height: 73vh;\n}\n\n.table.legal-structures {\n    /*width: calc(100vw - 60px);*/\n}\n\n.tableCenter,\n.tableCenter div {\n    /*margin: auto 0;*/\n    /*padding: 40px 0;*/\n    /*width: 100vw;*/\n    /*min-width: var(--container-width);*/\n    /*max-width: var(--container-width);*/\n    /*width: clamp(100vw, 70vw, 70vw);*/\n    max-height: calc(100vh - var(--header-height) - 80px);\n}\n\n.tableRight,\n.tableLeft,\n.tableCenter {\n    /*flex: 1;*/\n}\n\n.tipsRight {\n    margin: auto 0 0 auto;\n    transition: opacity 0.4s;\n    position: relative;\n    width: 260px;\n    max-width: 100%;\n}\n\n.tableRight {\n    position: relative;\n}\n\n.tableRight,\n.tableRight > div,\n.tableLeft {\n    display: flex;\n    flex-direction: column;\n    row-gap: 60px;\n    max-height: calc(100vh - var(--header-height));\n}\n\n.tableRight > div {\n    flex: 1;\n}\n\n.bottomDetails {\n    transition: opacity 0.4s;\n}\n\n/*.tableRight > div > div:first-child,*/\n/*.tableRight > div > div:last-child,*/\n/*.tableLeft > div:first-child,*/\n/*.tableLeft > div:last-child {*/\n/*    height: 200px;*/\n/*}*/\n\n.tableLeft {\n    position: relative;\n}\n\n.tableBottom {\n    margin: auto 0 0 0;\n    position: absolute;\n    transition: left 0.4s;\n    left: 0;\n}\n\n@media (max-width: 1920px) {\n    .hidden {\n        display: none;\n    }\n}\n\n@media (max-width: 2000px) and (min-width: 1570px) {\n    .tableBottom {\n        width: 27vw;\n    }\n}\n\n@media (max-width: 1570px) and (min-width: 1320px) {\n    .tableBottom {\n        width: 27vw;\n    }\n}\n\n.graphTip {\n    width: 100%;\n    /*width: 340px;*/\n    /*min-width: 340px;*/\n    font-weight: 300;\n    margin: auto 0 0;\n    /*font-size: 12px;*/\n}\n\n.details {\n    height: auto !important;\n    margin: auto;\n    right: 0;\n    left: 0;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    width: 300px;\n    max-width: 100%;\n}\n\n.actions {\n    display: flex;\n    column-gap: 169px;\n    row-gap: 16px;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n.actions button,\n.actions a {\n    width: 100%;\n}\n\n.btnContainer {\n    margin-top: 30px;\n}\n\n.checkboxesWrapper {\n    --width: 400px;\n    overflow: hidden;\n    width: var(--width);\n    margin-left: calc((var(--width) - var(--column-width)) / 2 * -1);\n}\n\n.checkboxes {\n    position: relative;\n    background: #fff;\n    padding: 25px 58px;\n    width: 322px;\n    border-radius: 10px;\n    border: 1px solid var(--primary-color);\n    margin-top: 20px;\n    margin-left: 200px;\n    opacity: 0;\n    transition:\n        margin 0.4s,\n        opacity 0.4s;\n}\n\n.checkboxes:not(.checkOpen) {\n    pointer-events: none;\n}\n\n.checkboxes.checkOpen {\n    margin-left: 0;\n    opacity: 1;\n}\n\n.checks {\n    width: 160px;\n    position: relative;\n    z-index: 90;\n    max-width: 100%;\n\n    /*margin-top: 100px*/\n}\n\n.fofChecks {\n    max-width: 100%;\n    width: 225px;\n    margin-left: auto;\n    margin-top: 100px;\n    position: relative;\n    z-index: 10;\n}\n\n.detailsPlaceholder {\n    margin: auto 0 0 auto;\n    padding-top: 30vh;\n    color: var(--primary-color);\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    position: absolute;\n    z-index: 1;\n    /*text-align: center;*/\n    left: 0;\n    right: 0;\n    width: 260px;\n    transition: opacity 0.4s;\n    max-width: 100%;\n}\n\n.detailsPlaceholderImg {\n    width: 20px;\n    min-width: 20px;\n    transform: rotate(180deg);\n    /*margin: auto*/\n    position: absolute;\n    left: -26px;\n}\n\n/*@media (max-width: 1920px) {*/\n/*    .table {*/\n/*        width: 100vw;*/\n/*    }*/\n/*}*/\n\n/*@media (max-height: 1200px) {*/\n/*    .tipsRight.checkOpen {*/\n/*        opacity: 0;*/\n/*    }*/\n/*}*/\n\n@media (min-width: 3000px) {\n    .table {\n        grid-template-columns: 1fr var(--container-width) 1fr;\n    }\n}\n\n@media (min-width: 2000px) {\n    .details {\n        margin: auto auto;\n        right: 0;\n        left: 0;\n    }\n\n    .tipsRight {\n        margin: auto;\n    }\n\n    .detailsPlaceholder {\n        margin: auto;\n        left: 0;\n        right: 0;\n    }\n}\n\n/*@media (min-width: 2000px) and (max-width: 3000px) {*/\n/*    .table {*/\n/*        grid-template-columns: 1fr 50vw 1fr;*/\n/*    }*/\n/*}*/\n\n@media screen-lg-min {\n    .table {\n        padding-top: 50px;\n    }\n}\n\n@media screen-lg-max {\n    .table {\n        /*grid-template-columns: 1fr 40vh 1fr;*/\n    }\n}\n\n@media screen-md-max {\n    .table {\n        --column-width: 340px;\n        /*grid-template-columns: calc(var(--column-width) - var(--sidebar-collapsed-width)) auto var(--column-width);*/\n    }\n\n    .tipsRight,\n    .tableBottom {\n        position: absolute;\n        bottom: 0;\n    }\n\n    .tipsRight {\n        margin: auto;\n        /*left: 0;*/\n        right: 0;\n    }\n\n    .bottomDetails:not(.active) {\n        opacity: 0;\n    }\n}\n\n.bottomDetails:not(.active) .detailsPlaceholder {\n    opacity: 0;\n}\n\n@media (min-width: 1920px) {\n    .hidden {\n        left: var(--sidebar-expanded-width);\n    }\n\n    .details {\n        width: 370px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-lg-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-max"]}`,
	"table": `result-table-styles_table__DbpG2`,
	"main": `result-table-styles_main__r-zpW`,
	"legal-structures": `result-table-styles_legal-structures__wq9lN`,
	"tableCenter": `result-table-styles_tableCenter__hcoRv`,
	"tableRight": `result-table-styles_tableRight__o03NB`,
	"tableLeft": `result-table-styles_tableLeft__i-6cC`,
	"tipsRight": `result-table-styles_tipsRight__XQx5v`,
	"bottomDetails": `result-table-styles_bottomDetails__xAXye`,
	"tableBottom": `result-table-styles_tableBottom__2gv-Q`,
	"hidden": `result-table-styles_hidden__Ebnio`,
	"graphTip": `result-table-styles_graphTip__BwyuE`,
	"details": `result-table-styles_details__ukQVR`,
	"actions": `result-table-styles_actions__i7Fpz`,
	"btnContainer": `result-table-styles_btnContainer__+qDL6`,
	"checkboxesWrapper": `result-table-styles_checkboxesWrapper__5h5Jp`,
	"checkboxes": `result-table-styles_checkboxes__Xp9E2`,
	"checkOpen": `result-table-styles_checkOpen__VL3Nl`,
	"checks": `result-table-styles_checks__i1Rua`,
	"fofChecks": `result-table-styles_fofChecks__yXqDM`,
	"detailsPlaceholder": `result-table-styles_detailsPlaceholder__qqTMW`,
	"detailsPlaceholderImg": `result-table-styles_detailsPlaceholderImg__qubrD`,
	"active": `result-table-styles_active__5RALC`
};
export default ___CSS_LOADER_EXPORT___;
